import {Component, input, signal} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {LucideAngularModule} from 'lucide-angular';
import {PictureUtil} from '@shared/util/picture.util';

@Component({
  selector: 'app-cover-viewer',
  imports: [
    ReactiveFormsModule,
    FormsModule,
    LucideAngularModule
  ],
  templateUrl: './cover-viewer.component.html',
  styleUrl: './cover-viewer.component.scss',
})
export class CoverViewerComponent {

  public readonly MEDIA_QUERY = `(min-width: ${PictureUtil.THUMBNAIL_MAX_WIDTH + 1}px)`;
  public readonly THUMBNAIL_MEDIA_QUERY = `(max-width: ${PictureUtil.THUMBNAIL_MAX_WIDTH}px)`;

  public readonly thumbnailUrl = input.required<string>();
  public readonly url = input.required<string>();

  public readonly imageLoaded = signal(false);

  public onImageLoad(_event: Event) {
    this.imageLoaded.set(true);
  }

}
